import {map, Observable} from 'rxjs';
import {inject, Injectable} from '@angular/core';
import {BackendService, ICompanySettings} from '@core/api/data-access';
import {AuthStore} from '@auth/data-access';

@Injectable({
	providedIn: 'root',
})
export class CompanySettingsService extends BackendService {
	public readonly authStore: AuthStore = inject(AuthStore);

	constructor() {
		super('settings');
	}

	get(): Observable<ICompanySettings> {
		return this.apiService.get<ICompanySettings>(this.getUrl(''));
	}

	setCompanySettings(update: ICompanySettings): Observable<ICompanySettings> {
		return this.apiService.post<object, ICompanySettings>(this.getUrl(''), update).pipe(map(() => update));
	}
}
